export default {
  title: 'System Logs',
  name: 'Name',
  origin: 'Origin',
  level: 'Level',
  affectedEntities: 'Affected entities',
  user: 'User',
  time: 'Time',
  date: 'Date',
  cardViewSoon: 'Card view (soon)'
}
